// Components
import HomeHero from "../components/home/HomeHero.js";
import ServicesShort from "../components/home/ServicesShort.js";
import TrainersShort from "../components/home/TrainersShort.js";
import PriceListShort from "../components/home/PricelistShort.js";

// Assets
import "../assets/styles/home.css";
import heroVideoWebm from "../assets/videos/roy_gym_hero_vp9.webm";
import heroVideoMp4 from "../assets/videos/roy_gym_hero_h264.mp4";
import heroPoster from "../assets/images/home/hero-poster.jpg";

// Hooks
import { useContext } from "react";
import { mainContext } from "../context/mainContext.js";
import { useTranslation } from "../hooks/useTranslation";
import ScrollCue from "../visuals/ScrollCue.js";

export default function Home() {
  const t = useTranslation();
  const { appReady } = useContext(mainContext); // <-- gate

  return (
    <div id="homeDiv">
      {/* visually hidden H1 for SEO */}
      <h1 className="visually-hidden">{t("hero.h1")}</h1>
      <p className="visually-hidden">{t("hero.p")}</p>

      <HomeHero
        gate={appReady}               // <-- pass gate
        sources={{ webm: heroVideoWebm, mp4: heroVideoMp4 }}
        poster={heroPoster}
        headline={t("home.hero.slogen")}
      />
      <ScrollCue
        position="right"
        theme="light"
        cueOffset="clamp(12px, 4vh, 40px)"
        dotSize={6}
        mouseWidth={22}
        mouseHeight={36}
        lineBelow={30}
        mouseBase={6}
        mouseShift={24}
        duration={4}
      />
      <PriceListShort />
      <ServicesShort />
      <TrainersShort />
    </div>
  );
}
